var _rect, _path, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3927_32647",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3927_32647)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.775 10H18.7C18.2667 8.53333 17.4417 7.33333 16.225 6.4C15.0083 5.46667 13.6 5 12 5C10.05 5 8.39583 5.67917 7.0375 7.0375C5.67917 8.39583 5 10.05 5 12C5 13.2 5.27083 14.3 5.8125 15.3C6.35417 16.3 7.08333 17.1167 8 17.75V15H10V21H4V19H6.35C5.31667 18.1667 4.5 17.1458 3.9 15.9375C3.3 14.7292 3 13.4167 3 12C3 10.75 3.2375 9.57917 3.7125 8.4875C4.1875 7.39583 4.82917 6.44583 5.6375 5.6375C6.44583 4.82917 7.39583 4.1875 8.4875 3.7125C9.57917 3.2375 10.75 3 12 3C14.15 3 16.0375 3.6625 17.6625 4.9875C19.2875 6.3125 20.325 7.98333 20.775 10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3927_32647",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 12,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 12,
    height: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3927_32647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 21.1016C16.3321 21.1016 16.1899 21.0432 16.0732 20.9264C15.9564 20.8097 15.8981 20.6675 15.8981 20.4999V17.5358L13.0219 13.8597C12.869 13.6592 12.8458 13.4488 12.9523 13.2286C13.0587 13.0084 13.2412 12.8983 13.4997 12.8983H20.4997C20.7582 12.8983 20.9406 13.0084 21.0471 13.2286C21.1536 13.4488 21.1303 13.6592 20.9774 13.8597L18.1013 17.5358V20.5328C18.1013 20.6944 18.0469 20.8296 17.9382 20.9384C17.8293 21.0472 17.6941 21.1016 17.5326 21.1016H16.4997ZM16.9997 17.0902L19.3969 14.0358H14.6024L16.9997 17.0902Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFilter);
export default __webpack_public_path__ + "static/media/reset_filter.a738f6622278811262785d1dffd62f35.svg";
export { ForwardRef as ReactComponent };